import req from '../../api/request'
import { ENDPOINTS } from '../../api/endpoints'
import type { TeamRosterSummary } from '../../features/competition/operations/utils/resolveRosterForDivision'

interface RawRoster {
  id?: string
  uid?: string
  name?: string
  division_uid?: string | null
  lock_roster_date?: string | null
  is_registration_on?: number | boolean
}

/**
 * Lists every roster a team belongs to. `division_uid` is what lets the
 * Operations panel show the roster for the division the user opened.
 */
export const listTeamRosters = async (
  teamId: string
): Promise<TeamRosterSummary[]> => {
  const response = await req(ENDPOINTS.TEAMS.LIST_TEAM_ROSTERS(teamId))
  // This endpoint answers with a BARE ARRAY, not the usual `{ data: [...] }`
  // envelope — see `useRosterSelect` in `src/components/List/RosterSelectNew.jsx`,
  // which uses the awaited value directly. Destructuring `.data` here yielded
  // `undefined`, so every roster list came back empty and no roster ever matched
  // the selected division. Both shapes are accepted in case the envelope appears.
  const rosters: RawRoster[] = Array.isArray(response)
    ? response
    : Array.isArray(response?.data)
    ? response.data
    : []
  return rosters.map((roster) => ({
    id: String(roster.id ?? roster.uid ?? ''),
    name: roster.name ?? '',
    divisionUid: roster.division_uid ?? null,
    lockRosterDate: roster.lock_roster_date ?? null,
    isRegistrationOn: Boolean(roster.is_registration_on),
  }))
}
